
<div class="font-20 semibold mtb-20">
  <font class="font-required">*</font>
  Personal Email Verification
  <font class="font-required">(Required)</font>
</div>
<div class="container mb-10">
  Please verify or update your personal email address.  Our system allows only one personal email address, so additional personal email addresses will be removed.  We strongly encourage you to use the same email address associated with your State of Ohio OH|ID account, and this is the default choice.
  <br /><br /><b>How your personal email address is used:</b> Your personal email address is used to communicate with you when you use a Department of Education application as a parent, educator, or adult student.  This email address is published in our directory system.
  <br /><br />Please select only one of the following options.
</div>
<div class="divider gray-800"></div>
<div>
  <div class="container radio-button radio-bg mt-5">
    <input (change)="toggleshowHomeOhId()" id="home-1" name="home" type="radio" value="no-issues" [checked]="cService.homeEmailOption=='home-1'">
    <label class="gray-300 click-white display" for="home-1">
      <span class="pl-40">
        {{ tokenItem?.ohidEmail }} this is your OH|ID email
      </span>
    </label>
  </div>
  @if (showHomeOhId) {
    <div class=" mt-5 mb-5">
      <div class="card fluid">
        <div class="card__content align-center">
          Your OH|ID email has been selected as your personal email. If this looks good click next to continue.
        </div>
      </div>
    </div>
  }
  @if (tokenItem?.ohidEmail!=existingEmail && existingEmail) {
    <div class="container radio-button radio-bg">
      <input (change)="toggleshowHomeOtherId()" id="home-2" name="home" type="radio" value="no-issues" [checked]="cService.homeEmailOption=='home-2'">
      <label class="gray-300 click-white display" for="home-2"><span class="pl-40">{{ existingEmail}}</span></label>
    </div>
  }
  @if (showHomeOtherId && tokenItem?.ohidEmail!=existingEmail && existingEmail) {
    <div class=" mt-5 mb-5 relative">
      <div class="ds-text-field" style="margin-bottom: 0px;">
        <input class="ds-text-field__input" id="otheremail" type="text" name="otheremail" autocomplete="off" value="" [(ngModel)]="reenterExEmail"
          required="">
          <label for="firstName" class="ds-floating-label ">*Re-Type Selected Email</label>
          <div class="field-line-ripple blue"></div>
        </div>
        <div class="basis-50 ml-20"></div>
        @if (existingEmail==reenterExEmail) {
          <div class="check">
            <i class="fas fa-check"></i>
          </div>
        }
      </div>
      @if (existingEmail==reenterExEmail) {
        <div class=" mt-5 mb-5">
          <div class="card fluid">
            <div class="card__content align-center font-20">
              This email has been selected as your personal email. If this looks good click next to continue.
            </div>
          </div>
        </div>
      }
    }
  </div>
  @if (existingEmail==reenterExEmail) {
    <div class="divider gray-800"></div>
  }
  <div class="container radio-button radio-bg new">
    <input (change)="toggleshowHomeAddNew()" id="home-4" name="home" type="radio" value="no-issues" [checked]="cService.homeEmailOption=='home-4'">
    <label class="gray-400 click-white display" for="home-4">
      @if (!isbtnclicked || newEmail=='') {
        <span class="pl-40">
          Add New Personal Email
        </span>
      }
      @if (emailForm.valid && isbtnclicked) {
        <span class="pl-40">
          {{newEmail}}
        </span>
      }
    </label>
  </div>
  @if (showHomeAddNew) {
    <form [formGroup]="emailForm">
      <div class="flex-row pb-5 relative">
        <div class="inline-text-field-container flex-row gap-20">
          <div class="ds-text-field">
            <input class="ds-text-field__input" id="newEmail" type="text" name="newEmail" autocomplete="off" value=""
              required=""
              email="true"
              [(ngModel)]="newEmail" formControlName="newEmail">
              <label for="newEmail" class="ds-floating-label ">*Enter New Personal Email</label>
              <div class="field-line-ripple blue"></div>
              @if (emailForm.get('newEmail').invalid && emailForm.get('newEmail').errors && (emailForm.get('newEmail').dirty || emailForm.get('newEmail').touched)) {
                <div>
                  @if (emailForm.get('newEmail').hasError('required')) {
                    <span id="newEmail-errmsg" class="error errmsg">Enter Personal Email</span>
                  }
                  @if (emailForm.get('newEmail').hasError('email')) {
                    <span class="error errmsg">Please enter a valid email</span>
                  }
                </div>
              }
            </div>
            <div class="ds-text-field relative">
              <input class="ds-text-field__input" id="newEmail2" type="text" name="newEmail2" autocomplete="off" required="" [compareEqual]="newEmail" [(ngModel)]="reenterEmail" formControlName="newEmail2">
              <label for="newEmail2" class="ds-floating-label">*Re-Enter New Personal Email</label>
              <div class="field-line-ripple blue"></div>
              @if (emailForm.get('newEmail2').invalid && emailForm.get('newEmail2').errors && (emailForm.get('newEmail2').dirty || emailForm.get('newEmail2').touched)) {
                <div>
                  @if (emailForm.get('newEmail2').hasError('required')) {
                    <span id="newEmail2-errmsg" class="error errmsg">Re-enter Personal Email</span>
                  }
                </div>
              }
              @if (emailForm.get('newEmail2').invalid && emailForm.get('newEmail2').errors && (emailForm.get('newEmail2').dirty || emailForm.get('newEmail2').touched)) {
                <div>
                  @if (!emailForm.get('newEmail2').hasError('required') && emailForm.get('newEmail2').hasError('compareEqual')) {
                    <span id="newEmail2-errcomparemsg" class="error errmsg">Email do not match</span>
                  }
                </div>
              }
              @if (emailForm.valid) {
                <div class="check">
                  <i class="fas fa-check"></i>
                </div>
              }
            </div>
          </div>
          <div class="container flex gap-20 justify-end">
            <button title="Cancel" id="" class="secondary border-red rounded-full hover-red hover-font-white flex-row-reverse" (click)="cancleNewHomemeail()">
              <div class="btn-txt font-red bold">Cancel</div>
            </button>
            <button title="Add New Personal Email" class="rounded-full hover-blue-800 black" (click)="addNewHomeEmail()" [disabled]="!emailForm.valid">
              <div class="btn-txt font-white">Add New Personal Email</div>
            </button>
          </div>
        </div>
      </form>
    }
    @if (!cService.isHomeEmailRequired) {
      <div>
        <div class="container radio-button radio-bg mt-5">
          <input (change)="toggleshowHomeDontUse()" id="home-3" name="home" type="radio" value="no-issues" [checked]="cService.homeEmailOption=='home-3'">
          <label class="gray-300 click-white display" for="home-3">
            <span class="pl-40">I don’t want to provide my personal email address</span>
          </label>
        </div>
        @if (showHomeDontUse) {
          <div class=" mt-5 mb-5">
            <div class="card fluid">
              <div class="card__content align-center">
                Though you are not required to provide your personal email address, we strongly encourage to provide it as an alternative means to receive important updates via email. Please note that you must have at least one email for you in our system (personal or office email).
              </div>
            </div>
          </div>
        }
      </div>
    }

    <div class="divider gray-500 mtb-20"></div>
    <div class="container flex mobile">
      <span class="basis-33">
        <span class="flex justify-start">
          <button title="Back" id="" class="secondary border-red rounded-full hover-red hover-font-white flex-row-reverse mobile" (click)="updateStepCount(false)">
            <div class="btn-txt font-red bold">Back</div>
          </button>
        </span>
      </span>
      <span class="basis-33">
        <span class="flex justify-center">
          <!--<button id="" title="Skip Verification" class="secondary border-red rounded-full hover-red hover-font-white flex-row-reverse mobile" (click)="cService.backtoapplication()">
          <div class="btn-txt font-red bold">Skip Verification for Now</div>
        </button>-->
      </span>
    </span>
    <span class="basis-33">
      <span class="flex justify-end">
        <button title="Next" class="rounded-full hover-blue-800 black mobile" [disabled]="getIsFormvalid()" (click)=updateStepCount(true)>
          <div class="btn-txt font-white bold">Next</div>
        </button>
      </span>
    </span>
  </div>
